import { _Web } from "../webs/types.js";
import { CreateClientsidePage, ClientsidePageFromFile } from "./types.js";
import { SharePointQueryableCollection } from "../sharepointqueryable.js";
_Web.prototype.getClientsideWebParts = function () {
    return this.clone(SharePointQueryableCollection, "GetClientSideWebParts")();
};
_Web.prototype.addClientsidePage =
    function (pageName, title = pageName.replace(/\.[^/.]+$/, ""), layout, promotedState) {
        return CreateClientsidePage(this, pageName, title, layout, promotedState);
    };
_Web.prototype.loadClientsidePage = function (path) {
    return ClientsidePageFromFile(this.getFileByServerRelativePath(path));
};
//# sourceMappingURL=web.js.map